<template>
  <div class="blocks">
    <div v-for="project, i of orderedProjects" class="block">
      <!-- Title -->
      <h3 :id="project.id">{{ project.title }}</h3>

      <!-- Description -->
      <p>{{ project.description }}</p>

      <!-- Awards -->
      <ul v-if="project.awards">
        <li v-for="award of project.awards">
          <a :href="award.url" target="_blank">
            <svg-icon name="award" class="award-icon"/>
            <span>{{ award.name }}</span>
          </a>
        </li>
      </ul>

      <!-- Partners -->
      <ul v-if="project.partners">
        <span :title="$t('partners')"><svg-icon name="users" class="simple-icon"/></span>
        <li v-for="partner of project.partners" class="compact-links separator-between">
          <a :href="partners[partner].url" :title="partners[partner].name" target="_blank">
            {{ partners[partner].shortname ? partners[partner].shortname : partner }}
          </a>
          <!-- <img v-if="partners[partner].img" :src="partners[partner].img" style="width: 5rem;"/> -->
        </li>
      </ul>

      <!-- Image -->
      <img v-if="project.img"
           :class="{'project-img': true, 'no-border': project.style && project.style['no img border']}"
           @click="openFullscreenImg(project.img, $event)"
           :true-src-url="getImgUrl(project.img)"
           v-lazy="getImgUrl(project.img)">

      <!-- Links -->
      <div>
        <ul v-if="project.urls">
          <span :title="$t('links')"><svg-icon name="external-link" class="simple-icon"/></span>
          <li v-for="url of project.urls" class="compact-links separator-between">
            <a :href="url.url" :title="url.name" target="_blank">{{ url.name }}</a>
          </li>
        </ul>
        <a v-if="project.url" :href="project.url" target="_blank">
          <svg-icon name="external-link"/>
        </a>
        <a v-if="project.github" :href="project.github"
           :title="$t('source code')" target="_blank">
          <svg-icon name="github"/>
        </a>
        <a v-if="project.gitlab" :href="project.gitlab"
           :title="$t('source code')" target="_blank">
          <svg-icon name="gitlab"/>
        </a>
      </div>

      <!-- Techs -->
      <ul v-if="project.techs">
        <svg-icon name="settings" class="simple-icon"/>
        <li v-for="tech of project.techs" class="tech separator-between">
          {{ tech }}
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
  import {getImgUrl} from '../utils.js'

  export default {
    props: ['projects', 'order', 'partners'],
    methods: {
      getImgUrl,
      openFullscreenImg (img, event) {
        this.$fullscreenImg.$emit(
          'set',
          {
            src: this.getImgUrl(img, false),
            loading: this.getImgUrl(img, true)
          },
          event)
      }
    },
    computed: {
      orderedProjects () {
        return Object.values(this.order).map(id => {
          let project = this.projects[id]
          project.id = id
          return project
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ProjectList.vue